(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product__form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  // Select all matching elements
  const swatches = document.querySelectorAll('.swatch-element');

  // Create a ResizeObserver to watch for size changes
  const resizeObserver = new ResizeObserver(entries => {
    entries.forEach(entry => {
      const element = entry.target;
      if (element.offsetWidth > 200) {
        element.classList.add('wide-swatch');
      } else {
        element.classList.remove('wide-swatch');
      }
    });
  });

  // Attach the observer to each element
  swatches.forEach(swatch => {
    resizeObserver.observe(swatch);
  });
});
  } catch(e) { console.error(e); }
})();

})();
